<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput label="Descripción" type="text" name="descricion" id="descripcion" rules="required" v-model="data.description" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Precio" type="number" step="any" name="precio" id="precio" rules="required" v-model="data.price" class="mb-0"/>
                <small>Gastos de gestión no incluidos - (Online: {{ gd['cantidad'] | formatear_precio }} / {{ parseFloat(data.price) + gd['cantidad'] | formatear_precio }}).</small>
            </b-col>
            <b-col cols="12 mt-3">
                <b-btn type="submit">Continuar</b-btn>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        created() {
            this.data.price_management = this.gd['cantidad'];
            this.data.price_management_interno = this.gd['interno']
        },
        computed: {
            gd() {
                return this.$store.getters.getGd['venta_entrada_online'];
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            },
        }
    }
</script>